import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./reducers";
import { WagmiConfig, createClient } from "wagmi";
import { ConnectKitProvider, getDefaultClient } from "connectkit";
import { arbitrum } from "wagmi/chains";
const alchemyId = process.env.alchemyId;

const chains = [ arbitrum ];

const client = createClient(
  getDefaultClient({
    appName: "Vertex Leaderboard",
    alchemyId,
    chains,
  })
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <WagmiConfig client={client}>
        <ConnectKitProvider theme={"midnight"}>
          <App />
        </ConnectKitProvider>
      </WagmiConfig>
    </Provider>
  </React.StrictMode>
);
